import React, { lazy, Suspense } from "react"
import { OrderShift } from "../../model/Screens"
import { Spacer } from "./Spacer"
import ImageAsset from "../../model/Assets"
import Popup from "reactjs-popup"
import 'cropperjs/dist/cropper.min.css'
import { LinkScreen } from "../action_links/LinkScreen"
import { MachineContext } from "../fsm/useMachine"
import { SET_AUTOPLAY, CHANGE_PREVIEW_IMG, SET_POSITION, SET_SIZE, DELEGATE, MARK_ALL_INACTIVE } from "../fsm/types"
import VideoFlowObject from "../../model/VideoFlowObject"
import { GalleryPreview } from "./Gallery"
import { GalleryEdit } from "./Gallery"
import {Image as ImageIcon, Crop, PlayCircle, Link, XCircle} from "react-feather"
import GalleryIcon from "../icons/GalleryIcon"
import { LayerDown, LayerUp } from "../icons/LayerIcons"
import { CornerRadiusPicker } from "./CornerMenu"
import { BorderPicker } from "./BorderMenu"
import ShapeFlowObject from "../../model/ShapeFlowObject"
import { CornerRadiusIcon } from "../icons/CornerRadiusIcon"
import { BorderIcon } from "../icons/BorderIcon"
import Tooltip from "@material-ui/core/Tooltip"
const Cropper = lazy(() => import("react-cropper"));

interface Props {
    sendOrderChange(order: OrderShift): void
}

/**
 * Representation of subset of controls across all object types.
 * @props input: default styling for `input` tags.
 * @props toggleLinkScreen: boolean flag for toggling link modal
 */
export const MediaControls: React.FC<Props> = ({
    sendOrderChange,
}) => {
    const [current, send] = React.useContext(MachineContext)
    const currentObject = current.context.currentObject!
    const [isWide, setIsWide] = React.useState(false)


    const onClick = () => {
        send({ type: DELEGATE, payload: { type: SET_AUTOPLAY, to: !(currentObject as VideoFlowObject).autoPlay }, id: currentObject.id })
    }

    const changePreviewImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault()
        let file = e.target.files![0]
        const newImg = ImageAsset.default({ __tag: "file", value: file }, true, file.name)
        let localImg = new Image();
        let reader = new FileReader()
        if (newImg.externalURL.__tag === "file")
            reader.readAsDataURL(newImg.externalURL.value)
        reader.onloadend = () => {
            if (reader.readyState == 2 && typeof reader.result == "string") {
                localImg.src = reader.result;
                newImg.externalURL = { __tag: "string", value: reader.result }

                localImg.onload = function () {
                    send({ type: DELEGATE, payload: { type: CHANGE_PREVIEW_IMG, img: newImg }, id: currentObject.id })
                    if (localImg.width > localImg.height) {
                        const aspectRatio = localImg.height / localImg.width
                        localImg.height = currentObject.frame.height
                        localImg.width = currentObject.frame.height / aspectRatio
                    } else {
                        const aspectRatio = localImg.width / localImg.height
                        localImg.width = currentObject.frame.width
                        localImg.height = currentObject.frame.width / aspectRatio
                    }
                    send({ type: DELEGATE, payload: { type: SET_SIZE, width: localImg.width, height: localImg.height }, id: currentObject.id })

                    const x = current.context.flow.viewSize.width / 2 - (currentObject.frame.width) / 2
                    const y = current.context.flow.viewSize.height / 2 - (currentObject.frame.height) / 2

                    send({ type: DELEGATE, payload: { type: SET_POSITION, x, y }, id: currentObject.id })
                    send({ type: MARK_ALL_INACTIVE })
                }



            }
        }
    }



    return (
        <div id="objectControls" className="objectControls">
            <form>
                {(currentObject?.type != "text" && currentObject?.type != "shape") && (
                    <React.Fragment>
                        <label title={currentObject?.type === "image" ? "Change Image" : "Change Preview"}>
                            <ImageIcon
                                className="button_controls feather"
                                title={currentObject?.type === "image" ? "Change Image" : "Change Preview"}
                            />
                            <input
                                type="file"
                                accept={"image"}
                                className="hidden"
                                onChange={changePreviewImage}
                            />
                        </label>
                        <Spacer width={5} height={10} />
                        <Popup
                            trigger={
                                <Tooltip title="Crop Image">
                                    <Crop className="buttonControls control_image feather" />
                                </Tooltip>
                            }
                            modal>
                            {(close: () => void) => (
                                <CropModal close={close} />
                            )}
                        </Popup>
                        <Spacer width={5} height={10} />
                        {currentObject.type == "video" && (
                            <Tooltip title={`Autoplay: ${(currentObject as VideoFlowObject).autoPlay ? "On" : "Off"}`}>
                                <PlayCircle
                                    className={`control_image feather ${(currentObject as VideoFlowObject).autoPlay ? "on" : "off"}`}
                                    onClick={onClick}
                                />
                            </Tooltip>
                        )}
                    </React.Fragment>
                )}
                {(currentObject?.type != "pdf" &&
                    currentObject?.type != "video" &&
                    currentObject?.type != "audio" &&
                    currentObject?.type != "gallery") && (
                        <Popup
                            trigger={
                            <Tooltip title="Add Link">
                                <Link className="buttonControls control_image feather" />
                            </Tooltip>
                        }
                            on="click"
                            position="bottom center"
                            closeOnDocumentClick
                            closeOnEscape
                            className={!isWide ? "linkmenu" : "linkmenu-wide"}
                        >
                            {(close: () => void) => <LinkScreen close_screen={() => {
                                setIsWide(false)
                                close()
                            }} setIsWide={setIsWide} />}
                        </Popup>
                    )}
                {(currentObject?.type == "pdf" ||
                    currentObject?.type == "image" ||
                    currentObject?.type == "video" ||
                    currentObject?.type == "gallery" ||
                    currentObject?.type == "shape") && (
                        <React.Fragment>
                            {(currentObject?.type !== "shape" ||
                              (currentObject as ShapeFlowObject).shapeType === "rectangle" ||
                              (currentObject as ShapeFlowObject).shapeType === "roundedRectangle") && (
                                <Popup
                                    trigger={
                                        <Tooltip title="Set Corner Radius">
                                            <CornerRadiusIcon className="buttonControls control_image feather" />
                                        </Tooltip>
                                    }
                                    on="click"
                                    position="bottom left"
                                    closeOnDocumentClick
                                    closeOnEscape
                                    className={"cornerpicker"}
                                >
                                    {(close: () => void) => <CornerRadiusPicker close={close} />}
                                </Popup>
                            )}
                            <Popup
                                trigger={
                                    <Tooltip title="Set Border">
                                        <BorderIcon
                                            className="buttonControls control_image feather"
                                            active={currentObject.borderWidth > 0}
                                        />
                                    </Tooltip>
                                }
                                on="click"
                                position="bottom left"
                                closeOnDocumentClick
                                closeOnEscape
                                className={"borderpicker"}
                            >
                                {(close: () => void) => <BorderPicker close={close} />}
                            </Popup>
                        </React.Fragment>
                    )}
                <Spacer width={10} height={10} />                
                <Tooltip title="Send Backward">
                <LayerDown className="buttonControls padding_2_5 double_left feather buttonControlsMarginTop" onClick={() => sendOrderChange(OrderShift.DOWN)} />
                </Tooltip>                
                <Spacer width={5} height={10} />
              
                <Tooltip title="Send Forward">
                <LayerUp className="buttonControls padding_2_5 feather buttonControlsMarginTop"
                onClick={() => sendOrderChange(OrderShift.UP)}/>
                </Tooltip>                
            </form>
        </div>
    )
}

MediaControls.displayName = "MediaControls"
export default MediaControls

export const CropModal: React.FC<{ close: () => void }> = ({ close }) => {
    const [current, send] = React.useContext(MachineContext)
    const currentObject = current.context.currentObject!
    // const [cropData, setCropData] = React.useState("#");
    const [cropper, setCropper] = React.useState<any>();

    const updateCropImage = () => {
        let croppedImage = cropper?.getCroppedCanvas().toDataURL();
        if (croppedImage) {
            const localImg = new Image();

            const newImage = ImageAsset.default({ __tag: "string", value: croppedImage})

            localImg.src = croppedImage;
            localImg.onload = function () {
                send({ type: DELEGATE, payload: { type: CHANGE_PREVIEW_IMG, img: newImage }, id: currentObject.id })

                if (localImg.width > localImg.height) {
                    const aspectRatio = localImg.height / localImg.width
                    localImg.height = currentObject.frame.height
                    localImg.width = currentObject.frame.height / aspectRatio
                } else {
                    const aspectRatio = localImg.width / localImg.height
                    localImg.width = currentObject.frame.width
                    localImg.height = currentObject.frame.width / aspectRatio
                }

                send({ type: DELEGATE, payload: { type: SET_SIZE, width: localImg.width, height: localImg.height }, id: currentObject.id })

                const x = current.context.flow.viewSize.width / 2 - (currentObject.frame.width) / 2
                const y = current.context.flow.viewSize.height / 2 - (currentObject.frame.height) / 2

                send({ type: DELEGATE, payload: { type: SET_POSITION, x, y }, id: currentObject.id })
            }

        }
    }

    if (currentObject.originalImageAsset!.externalURL.__tag === "file") {
        throw new Error("display asset is a file and MUST be a string")
    }

    return (
        <div className="modal">
            <div className="header"> 
                <button
                className="button"
                onClick={() => {
                    updateCropImage();
                    close();
                }}
                >
                Save
                </button>
                <span>Crop</span>
                <a className="close top_margin_link" onClick={close}>
                    <XCircle className="feather" />
                </a>
            </div>
            <div className="content">
                <Suspense fallback={<h2>Loading</h2>}>
                    <Cropper
                        className={"crop"}
                        style={{ height: 600, width: '100%' }}
                        src={currentObject.originalImageAsset!.externalURL.value}
                        aspectRatio={1}
                        guides={true}
                        responsive={true}
                        autoCropArea={1}
                        checkOrientation={false}
                        //@ts-ignore
                        onInitialized={(instance) => {
                            setCropper(instance);
                        }}
                    />
                </Suspense>
            </div>

        </div>
    )
}
